import HorizontalLine from '@src/sld/components/Line/HorizontalLine';
import BreakerStack1 from '@src/sld/sagebrush/sagebrush_b40/components/BreakerStack1';
import Switch1Units from '@src/sld/sagebrush/sagebrush_b40/components/Switch1Units';
import Switch2Units from '@src/sld/sagebrush/sagebrush_b40/components/Switch2Units';
import TopSwitchResistorSection from '@src/sld/sagebrush/sagebrush_b40/components/TopSwitchResistorSection';
import UnitProvider from '@src/sld/sagebrush/sagebrush_b40/components/UnitContext';
import storeConnector from '@store/storeConnector';
import { ReactElement } from 'react';

function SageBrushB40Diagram(): ReactElement {
  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      xlinkHref='http://www.w3.org/1999/xlink'
      viewBox='125 25 1300 645'
      xmlSpace='preserve'
      colorInterpolationFilters='sRGB'
      className='st10'
      style={{ fill: 'none', stroke: 'currentColor', overflowX: 'auto' }}
    >
      <title>Sagebrush B40</title>

      <TopSwitchResistorSection
        translateXCoordinate={-85}
        translateYCoordinate={-20}
      />
      <BreakerStack1 />
      <HorizontalLine
        color='white'
        width={0.5}
        length={567}
        translateXCoordinate={380}
        translateYCoordinate={315}
      />
      <UnitProvider>
        <Switch1Units />
        <Switch2Units />
      </UnitProvider>
    </svg>
  );
}

export default storeConnector(SageBrushB40Diagram, {
  config: ['siteMeta'],
});
